var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"twitter"),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":1},React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1"},React.createElement("path",{"id":"twitter","d":"M18.56,48C40.82,48,53,29.5,53,13.51c0-.53,0-1,0-1.57a24.46,24.46,0,0,0,6-6.26,24.16,24.16,0,0,1-7,1.9A12.13,12.13,0,0,0,57.37.89a24.37,24.37,0,0,1-7.68,2.93A12.12,12.12,0,0,0,28.74,12.1a11.92,11.92,0,0,0,.32,2.76A34.35,34.35,0,0,1,4.11,2.22,12.12,12.12,0,0,0,7.85,18.38a12,12,0,0,1-5.48-1.52V17a12.1,12.1,0,0,0,9.71,11.86,12,12,0,0,1-3.19.43,12.24,12.24,0,0,1-2.28-.22A12.12,12.12,0,0,0,17.92,37.5a24.25,24.25,0,0,1-15,5.18A25.06,25.06,0,0,1,0,42.51,34.23,34.23,0,0,0,18.56,48"})))]);
}

Twitter.defaultProps = {"viewBox":"0 0 59 47.95"};

module.exports = Twitter;

Twitter.default = Twitter;
